import Fab from '@material-ui/core/Fab';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import LinearProgress from '@material-ui/core/LinearProgress';
import Typography from '@material-ui/core/Typography';
import {
  Close,
} from '@material-ui/icons';
import classNames from 'classnames';
import React, {
  Component,
} from 'react';
import Dropzone from 'react-dropzone';
import {
  translate,
} from '../../../../helperFunctions/translation';
import Directives from '../../../Directives/Directives';
import SnackBarComponent from '../../../SnackBarComponent/SnackBarComponent';
import generalClasses from '../../GeneralFormComponent/GeneralFormComponent.module.scss';
import {
  IGalleryField,
} from '../formFields';
import classes from './GalleryField.module.scss';
import { images } from '../../../../assets/image';

interface IProps extends IGalleryField {
  errors?: any;
  touched?: any;

  onAddImage(name: string, image: File): void;

  onRemoveImage(name: string, imageIndex: number): void;
}
interface IState {
  open: boolean;
}

class GalleryField extends Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      open: false,
    };
  }

  handleClose = () => {
    this.setState({
      open: false,
    });
  };

  onDrop = (acceptedFiles: File[], rejectedFiles: any) => {
    let check = false;
    for (const file of acceptedFiles) {
      // check for ratio if exists
      if (this.props.accept === 'image/*' && this.props.ratio) {
        check = true;
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (entry: any) => {
          const image = new Image();
          image.src = entry.target.result;
          image.onload = () => {
            const aspectRatio = image.width / image.height;
            const ratio = this.props.ratio || 0;
            if (aspectRatio < ratio) {
              console.log(aspectRatio);
              this.setState({
                open: true,
              });
              SnackBarComponent.getInstance().openSnackbar(translate('addImageErrorMessage', {
              }), 8000, 'error');
            } else {
              SnackBarComponent.getInstance().openSnackbar(translate('addImageSuccessMessage', {
              }), 8000, 'success');
              this.props.onAddImage(this.props.name, file);
            }
          };
        };
      }
      // check for size if exists
      if (this.props.accept === 'image/*' && this.props.size) {
        check = true;
        if (Math.round(file.size / 1000) > this.props.size) {
          this.setState({
            open: true,
          });
          SnackBarComponent.getInstance().openSnackbar(translate('addImageErrorMessage', {
          }), 8000, 'error');
        } else {
          SnackBarComponent.getInstance().openSnackbar(translate('addImageSuccessMessage', {
          }), 8000, 'success');
          this.props.onAddImage(this.props.name, file);
        }
      }
      // if no size or ratio specified just add the image
      if (!check) {
        SnackBarComponent.getInstance().openSnackbar(translate('addImageSuccessMessage', {
        }), 8000, 'success');
        console.log('gallery field', file);
        this.props.onAddImage(this.props.name, file);
      }
    }
  };

  getCloseButton = (props: IProps, index: number) => {
    if (!props.processing) {
      return (
        <Fab
          size="large"
          color="secondary"
          aria-label="remove"
          onClick={() => props.onRemoveImage(props.name, index)}
          className={classes.remove}
        >
          <Close />
        </Fab>
      );
    }
  };

  getImage(element: any, index: number) {
    return (
      <div className={classes.thumb} key={`${element.imageUrl}${element.key}`}>
        <div className={classes.thumbInner}>
          {this.props.accept === 'image/*'
            ? <img src={element.imageUrl} className={classes.img} />
            : (
              <video className={classes.img} width="400" controls preload="metadata">
                <source src={element.imageUrl} type="video/mp4" />
              </video>
            )}
          {this.getCloseButton(this.props, index)}
        </div>
      </div>
    );
  }

  getVideo(element: any, index: number) {
    return (
      <div className={classes.thumb} key={`${element.videoUrl}${element.key}`}>
        <div className={classes.thumbInner}>
          <img
            src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ7mqlAlw416LNquaSAtkJG-Ace7tW8I_cjD8_KPI5DDWGZRyVt"
            className={classes.img}
            alt="gallery video"
          />
          {this.getCloseButton(this.props, index)}
        </div>
      </div>
    );
  }

  makeFilePreview = (element: any) => {
    if (element.type.match(/video\/*/g)) {
      return (
        <img
          src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ7mqlAlw416LNquaSAtkJG-Ace7tW8I_cjD8_KPI5DDWGZRyVt"
          className={classes.img}
          alt="gallery video"
        />
      );
    }
    if (element.type.match(/image\/*/g)) {
      return <img src={element.preview} className={classes.img}/>;
    }
    if (element.type.match(/csv\/*/g)) {
      return (
        <img
          src={images.csvPlaceholder}
          className={classes.placeHolder}
          alt="csv placeholder"
        />
      );
    }
    if (element.type.match(/application\/*/g)) {
      return (
        <img
          src={images.xlsxPlaceHolder}
          className={classes.placeHolder}
          alt="xlsx placeholder"
        />
      );
    }
  };

  makeThumbnail = (element: any, index: number) => {
    if (element.preview) {
      return (
        <div className={classes.thumb} key={element.preview}>
          <div className={classes.thumbInner}>
            {this.makeFilePreview(element)}
            {this.getCloseButton(this.props, index)}
          </div>
        </div>
      );
    }
    if (element.type === 'video') {
      return this.getVideo(element, index);
    }
    return this.getImage(element, index);
  };

  render() {
    const {
      value,
      hideProgressBar,
    } = this.props;

    const thumbs = value!.map((element: any, index: number) => this.makeThumbnail(element, index));

    return (
      <div className={classes.container}>
        <FormControl className={generalClasses.filed}>
          <div className={classNames(classes.gallery)}>
            <Typography variant="caption" gutterBottom className={classNames(classes.label)}>
              {this.props.label}
            </Typography>
            <Dropzone
              onDrop={this.onDrop}
              accept={this.props.accept}
                    // name={this.props.name}
              multiple={!this.props.isLimitToOneImage}
            >
              {({
                getRootProps, getInputProps, isDragActive,
              }) => (
                <div
                  {...getRootProps()}
                  className={classNames('dropzone', {
                    'dropzone--isActive': isDragActive,
                  })}
                >
                  <input {...getInputProps()} />
                  {
                    isDragActive
                      ? <Typography variant="subtitle1" gutterBottom className={classes.dropMsg}>Drop files here...</Typography>
                      : (
                        <Typography variant="subtitle1" gutterBottom className={classes.dropMsg}>
                          {this.props.textMessage ? this.props.textMessage
                            : translate('addBranchPageFormDropzoneTextMessage', {}).replace('_SIZE_', `${this.props.size}`)}
                        </Typography>
                      )
                  }
                </div>
              )}
            </Dropzone>
            {!!thumbs.length && (
              <div className={classes.thumbsContainer}>
                {thumbs}
              </div>
            )}
          </div>
          <Directives dIf={this.props.errors[this.props.name] && this.props.touched[this.props.name]}>
            <FormHelperText className={generalClasses.error}>{this.props.errors[this.props.name]}</FormHelperText>
          </Directives>
          <Directives dIf={!(this.props.errors[this.props.name] && this.props.touched[this.props.name]) && this.props.warningMessage
        && this.props.value!.length === 0}
          >
            <FormHelperText>{this.props.warningMessage}</FormHelperText>
          </Directives>
        </FormControl>
        {
          this.props.processing && !hideProgressBar
            ? <LinearProgress />
            : null
        }
      </div>
    );
  }
}

export default GalleryField;
